/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrectionq3Inputs */

const en_qrerrorcorrectionq3 = /** @type {(inputs: Qrerrorcorrectionq3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

const de_qrerrorcorrectionq3 = /** @type {(inputs: Qrerrorcorrectionq3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoch`)
};

/**
* | output |
* | --- |
* | "High" |
*
* @param {Qrerrorcorrectionq3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrectionq3 = /** @type {((inputs?: Qrerrorcorrectionq3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrectionq3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrectionq3(inputs)
	return de_qrerrorcorrectionq3(inputs)
});
export { qrerrorcorrectionq3 as "qrErrorCorrectionQ" }